// extracted by mini-css-extract-plugin
export default {"wrapper":"Content_wrapper__mzamL","inner":"Content_inner__QwqN2"};